<template>
  <v-card v-if="model.id" class="elevation-2">
    <v-card-title class="text-h5">
      <h2 class="font-weight-bold text--primary">Solicitud</h2>
      <v-spacer></v-spacer>
        <span v-if="model.last_movement.estatus.formulario.actions">
            <span v-if="model.last_movement.estatus.formulario.actions.length == 1 ">
                <v-btn v-for="(action, index) in model.last_movement.estatus.formulario.actions" :key="index"
                    small :color="action.color" dark class="mr-1"
                    @click="successAction({ action:action.action, item: model, body:action})"> {{ action.title }}
                    <v-icon right dark v-if="action.icon">{{ action.icon }}</v-icon>
                </v-btn>
            </span>
            <v-menu offset-y v-else>
                <template v-slot:activator="{ attrs, on }">
                    <v-btn color="primary" class="ma-1" v-bind="attrs" v-on="on" small>Opciones</v-btn>
                </template>
                <v-list dense>
                    <v-list-item v-for="(action, index) in model.last_movement.estatus.formulario.actions" :key="index" link
                        @click="successAction({action:action.action, item: model, body:action})">
                        <v-list-item-title v-text="action.title" />
                    </v-list-item>
                </v-list>
            </v-menu>
        </span>
    </v-card-title>
    <v-card-subtitle>
      <span v-if="model.descripcion.solicitante_id" class="title text--black font-weight-black font-weight-bold">
        {{model.descripcion.solicitante.NombreCompleto}}
      </span>
      <span v-else class="title text--black font-weight-black font-weight-bold">
        {{model.descripcion.solicitante}}
      </span>
    </v-card-subtitle>
    <v-card-text>
        <v-row dense>
            <v-col cols="6" sm="6" md="4">
                <label class="font-weight-bold subtitle-1 text--primary">Folio: </label>
                <p class="font-weight-bold text--secondary">
                    {{model.folio}}
                </p>
            </v-col>
            <v-col cols="6" sm="6" md="4">
                <label class="font-weight-bold subtitle-1 text--primary">tipo Actividad: </label>
                <p class="font-weight-bold text--secondary">
                    {{model.actividad.nombre}}
                </p>
            </v-col>
            <v-col cols="12" sm="6" md="4">
                <label class="font-weight-bold subtitle-1 text--primary">Estado: </label>
                <p class="font-weight-bold text--secondary">
                    <v-chip class="my-1" outlined label
                        :color="model.last_movement.estatus.color">
                      {{model.last_movement.estatus.estatus}}
                    </v-chip>
                </p>
            </v-col>

            <v-col cols="12" v-if="model.tipo_actividade_id === 4">
                <v-row dense>
                    <v-col cols="6" sm="6" md="4">
                        <label class="font-weight-bold subtitle-1 text--primary">Equipo: </label>
                        <p class="font-weight-bold text--secondary">
                            {{model.descripcion.equipo}}
                        </p>
                    </v-col>
                    <v-col cols="6" sm="6" md="4">
                        <label class="font-weight-bold subtitle-1 text--primary">Marca: </label>
                        <p class="font-weight-bold text--secondary">
                            {{model.descripcion.marca}}
                        </p>
                    </v-col>
                    <v-col cols="6" sm="6" md="4">
                        <label class="font-weight-bold subtitle-1 text--primary">Serie: </label>
                        <p class="font-weight-bold text--secondary">
                            {{model.descripcion.serie}}
                        </p>
                    </v-col>
                </v-row>
            </v-col>

            <v-col cols="12" sm="12" md="6">
                <label class="font-weight-bold subtitle-1 text--primary">Falla Reportada: </label>
                <p class="font-weight-bold text--secondary">
                    {{ (model.descripcion.fallaReportada)? model.descripcion.fallaReportada : model.descripcion.reporte}}
                </p>
            </v-col>
            <v-col cols="12" sm="12" md="6">
                <label class="font-weight-bold subtitle-1 text--primary">Observaciones: </label>
                <p class="font-weight-bold text--secondary">
                    {{model.descripcion.observaciones}}
                </p>
            </v-col>
            <v-col cols="12" sm="6">
                <label class="font-weight-bold subtitle-1 text--primary">Atencion: </label>
                <p class="font-weight-bold text--secondary">
                    <v-chip class="my-2" color="primary" outlined label>
                        {{model.tipo_servicio.nombre}}
                    </v-chip>
                </p>
            </v-col>
        </v-row>

        <v-row dense v-if="model.descripcion.programar">
            <v-col cols="12" sm="4">
                <label class="font-weight-bold subtitle-1 text--primary">Tiempo: </label>
                <p class="font-weight-bold text--secondary">
                    <v-chip
                        class="my-2"
                        color="success"
                        outlined
                        label>
                        {{model.descripcion.programar}}
                    </v-chip>
                </p>
            </v-col>
            <v-col cols="12" sm="6" v-if="model.descripcion.programar == 'Programado'">
                <label class="font-weight-bold subtitle-1 text--primary">Fecha Programada: </label>
                <p class="font-weight-bold text--secondary ma-0">
                    <span class="text--primary">Fecha Ingreso:</span> {{model.descripcion.fInicial}}
                </p>
                <p class="font-weight-bold text--secondary ma-0">
                    <span class="text--primary">Fecha Entrega:</span> {{model.descripcion.fFinal}}
                </p>
            </v-col>
        </v-row>
    </v-card-text>
        <InsumoPickingDialog
            v-if="get_dialogMain.dialog && get_dialogMain.type == 'addInsumos'"
            :model="itemInsumos" />
  </v-card>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import InsumoPickingDialog from '@/components/dialog/inventarios/InsumoPickingDialog'
export default {
  props: ['model'],
  data: () => ({
    itemInsumos: {}
  }),
  components: {
    InsumoPickingDialog
  },
  methods: {
    successAction (item) {
      this[item.action](item)
    },
    addInsumosView (item) {
      this.itemInsumos = {}
      this.itemInsumos = Object.assign({}, item.item)
      this.SHOW_DIALOG_MAIN({ type: 'addInsumos', with: 900, title: 'Agregar Insumos' })
    },
    returnedInsumosView (item) {},
    ...mapMutations(['SHOW_DIALOG_MAIN'])
  },
  computed: {
    ...mapGetters(['get_dialogMain'])
  }
}
</script>
<style>
</style>
